"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductFeaturing = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _reactRedux = require("react-redux");
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
var _reactRouterDom = require("react-router-dom");
var _lodash = _interopRequireDefault(require("lodash"));
var _ConfrimationDialog = require("react-platform-components/dist/components/ConfrimationDialog/ConfrimationDialog");
var _config = require("../config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ProductFeaturingComponent(props) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var history = (0, _reactRouterDom.useHistory)();
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return {
        featurings: state.productFeaturingsReducer.featurings,
        cartItems: state.shoppingCartReducer.cartItems,
        user: state.auth.user
      };
    }),
    featurings = _useSelector.featurings,
    cartItems = _useSelector.cartItems,
    user = _useSelector.user;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showProductFeaturings = _useState2[0],
    setShowProductFeaturings = _useState2[1];
  var addItemToCart = function addItemToCart(item) {
    dispatch({
      type: "ADD_TO_CART",
      additionnalOptions: {
        salable_item_class: "ProductSubscription",
        meta_data: {
          product: Number(props.productId)
        }
      },
      item_uuid: item.uuid,
      redirectTo: "/cart",
      history: history
    });
  };
  var paySubscription = function paySubscription(item) {
    if (!_lodash.default.isEmpty(cartItems) && _config.CLEAN_CARTITEMS_IN_CART) {
      props.onConfirm(function () {
        var _cartItems$;
        dispatch({
          type: "DELETE_SHOPPING_CART_ITEM",
          id: (_cartItems$ = cartItems[0]) === null || _cartItems$ === void 0 ? void 0 : _cartItems$.id,
          onSuccess: function onSuccess() {
            addItemToCart(item);
          }
        });
      }, {
        title: "Votre panier est plein",
        description: "Voulez-vous remplacer le contenu de votre panier par ce produit.",
        confirmLabel: "Remplacer",
        cancelLable: "Annuller"
      });
    } else addItemToCart(item);
  };
  var handleProductFeaturing = function handleProductFeaturing() {
    dispatch({
      type: 'FETCH_PRODUCTS_FEATURINGS'
    });
    setShowProductFeaturings(true);
    dispatch({
      type: "FETCH_SHOPPING_CART_ITEMS",
      params: {
        'cart.id': user.carts[0].id
      }
    });
  };
  var handleClose = function handleClose() {
    setShowProductFeaturings(false);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    onClick: function onClick() {
      return handleProductFeaturing();
    },
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Feature",
    defaultMessage: "Feature"
  })), /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    open: showProductFeaturings,
    onClose: function onClose() {
      return handleClose();
    },
    className: "pb-8",
    maxWidth: "md",
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, {
    id: "product-featurings"
  }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Product featurings",
    defaultMessage: "Product featurings"
  })), /*#__PURE__*/_react.default.createElement(_core.DialogContent, null, !_lodash.default.isEmpty(featurings) ? /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    xs: 12,
    md: 12,
    spacing: 2
  }, featurings.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 3,
      key: index
    }, /*#__PURE__*/_react.default.createElement(_core.Card, {
      elevation: 4,
      className: "w-full"
    }, /*#__PURE__*/_react.default.createElement(_core.CardHeader, {
      title: /*#__PURE__*/_react.default.createElement(_core.Typography, {
        color: "secondary",
        variant: "h5",
        align: "center"
      }, item.name)
    }), /*#__PURE__*/_react.default.createElement(_core.CardContent, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "flex justify-center items-center mb-4"
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h1"
    }, item.price, " ", item.currency)), /*#__PURE__*/_react.default.createElement("div", null, item.description), /*#__PURE__*/_react.default.createElement("div", {
      className: "flex justify-center items-center mt-6"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "w-full",
      variant: "contained",
      color: "primary",
      size: "small",
      onClick: function onClick() {
        return paySubscription(item);
      }
    }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: "Buy",
      defaultMessage: "Buy"
    }))))));
  })) : /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h6"
  }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "no results...",
    defaultMessage: "no results..."
  }))))));
}
var ProductFeaturing = (0, _ConfrimationDialog.withConfirmationDialog)(ProductFeaturingComponent);
exports.ProductFeaturing = ProductFeaturing;